import React from "react";
import { Input } from "../ui/input";
import { Label } from "../ui/label";
import { useT } from "../../lib/i18n";
import ShippingEstimate from "./ShippingEstimate";

const COUNTRIES = [
  { code: "US", name: "United States" }, { code: "CA", name: "Canada" },
  { code: "GB", name: "United Kingdom" }, { code: "BR", name: "Brazil" }, { code: "PT", name: "Portugal" },
];

export default function AddressStep({ draft, setDraft, settings, addressValid }) {
  const { t } = useT();
  const c = draft.customer, a = draft.address;
  const setC = (k, v) => setDraft((d) => ({ ...d, customer: { ...d.customer, [k]: v } }));
  const setA = (k, v) => setDraft((d) => ({ ...d, address: { ...d.address, [k]: v } }));
  const field = "h-12 rounded-xl";
  return (
    <div className="space-y-4">
      <div><Label htmlFor="name">{t("c_name")}</Label><Input id="name" value={c.name} onChange={(e) => setC("name", e.target.value)} className={field} data-testid="shipping-name-input" /></div>
      <div><Label htmlFor="email">{t("c_email")}</Label><Input id="email" type="email" value={c.email} onChange={(e) => setC("email", e.target.value)} className={field} data-testid="shipping-email-input" /></div>
      <div><Label htmlFor="phone">{t("c_phone")}</Label><Input id="phone" value={c.phone || ""} onChange={(e) => setC("phone", e.target.value)} className={field} data-testid="shipping-phone-input" /></div>
      <div><Label htmlFor="line1">{t("c_addr")}</Label><Input id="line1" value={a.line1} onChange={(e) => setA("line1", e.target.value)} className={field} data-testid="shipping-address-line1-input" /></div>
      <div><Label htmlFor="line2">{t("c_apt")}</Label><Input id="line2" value={a.line2} onChange={(e) => setA("line2", e.target.value)} className={field} data-testid="shipping-address-line2-input" /></div>
      <div className="grid grid-cols-2 gap-3">
        <div><Label htmlFor="city">{t("c_city")}</Label><Input id="city" value={a.city} onChange={(e) => setA("city", e.target.value)} className={field} data-testid="shipping-city-input" /></div>
        <div><Label htmlFor="state">{t("c_state")}</Label><Input id="state" value={a.state} onChange={(e) => setA("state", e.target.value)} className={field} data-testid="shipping-state-input" /></div>
      </div>
      <div className="grid grid-cols-2 gap-3">
        <div><Label htmlFor="zip">{t("c_zip")}</Label><Input id="zip" value={a.postal_code} onChange={(e) => setA("postal_code", e.target.value)} className={field} data-testid="shipping-zip-input" /></div>
        <div><Label htmlFor="country">{t("c_country")}</Label>
          <select id="country" value={a.country} onChange={(e) => setA("country", e.target.value)} className="h-12 w-full rounded-xl border bg-white px-3 text-sm" data-testid="shipping-country-select">
            {COUNTRIES.map((co) => <option key={co.code} value={co.code}>{co.name}</option>)}
          </select>
        </div>
      </div>
      <p className="text-xs text-[hsl(var(--muted-foreground))]">{t("email_use")}</p>
      {addressValid && settings && <ShippingEstimate settings={settings} draft={draft} />}
    </div>
  );
}
